import { render, staticRenderFns } from "./tableDevice.vue?vue&type=template&id=42ca6645&scoped=true"
import script from "./tableDevice.vue?vue&type=script&lang=js"
export * from "./tableDevice.vue?vue&type=script&lang=js"
import style0 from "./tableDevice.vue?vue&type=style&index=0&id=42ca6645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca6645",
  null
  
)

export default component.exports